import { utils, writeFile } from 'xlsx';
import { LoadShortDate } from './LoadShortDate';
import { LoadShortTime } from './LoadShortTime';

const TelemetryToExcel = (telemetryHistory, fileName, formatTime = true) => {
  if (!telemetryHistory || telemetryHistory.length === 0) return;

  const roundToDecimal = (num, dp) => {
    return Math.round(num * Math.pow(10, dp)) / Math.pow(10, dp);
  };

  const keys = Object.keys(telemetryHistory[0]).filter(k => k !== "ts");

  const data = telemetryHistory.map(item => {
    const row = {};
    if (formatTime) {
      row.Date = LoadShortDate(item.ts);
      row.Time = LoadShortTime(new Date(item.ts).toISOString());
    } else {
      row.Timestamp = Number(item.ts);
    }

    keys.forEach(k => {
      const value = item[k];
      row[k] = typeof value === 'number' ? roundToDecimal(value, 5) : value ?? "";
    });

    return row;
  });



  const workbook = utils.book_new();
  const headers = formatTime? ['Date', 'Time', ...keys]: ['Timestamp', ...keys];
  const worksheet = utils.json_to_sheet(data,{header: headers});
  if (!formatTime) {
    const range = utils.decode_range(worksheet['!ref']);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cellAddress = utils.encode_cell({ r: R, c: 0 }); // assuming Timestamp is first column
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].t = 'n'; // number
        worksheet[cellAddress].z = '0'; // format: no decimals
      }
    }
  }


  utils.book_append_sheet(workbook, worksheet, 'Telemetry Data');

  const excelFileName = fileName ?? "telemetry_data.xlsx";
  writeFile(workbook, excelFileName);
};
export default TelemetryToExcel;